import React from "react";
import styled from "styled-components";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";
import { Link } from "react-router-dom";

const StyledPrivacyPolicy = styled(NanoFlex)`
  height: auto;
  padding: 0 150px;
  gap: 124px;

  @media only screen and (max-width: 815px) {
    gap: 84px;
  }

  .privacyPolicyTitle {
    gap: 30px;
    align-items: flex-start;
    height: auto;

    .spacer {
      height: auto;
      width: 40%;
    }

    .privacyTitle {
      width: 60%;
      gap: 24px;
      height: auto;
      flex-direction: column;

      h3 {
        font-weight: 500;
      }

      p {
        color: ${(props) => props.theme.color.primaryColors.darkPurple};
        opacity: 0.7;
        text-align: justify;
      }
    }
  }

  .privacyPolicyBlock {
    gap: 30px;
    align-items: flex-start;
    height: auto;

    .articleSubtitle {
      height: auto;

      h5 {
        font-weight: 500;
        color: ${(props) => props.theme.color.primaryColors.secFontColor};
        text-transform: none;
      }
    }
  }

  .PrivacyPolicyTopicBlock {
    width: 40%;
  }

  .privacyPolicyContentBlock {
    gap: 24px;
    width: 60%;
    height: auto;

    .title {
      h3 {
        font-weight: 500;
      }
    }

    .articleContent {
      gap: 16px;
      height: auto;

      p {
        color: ${(props) => props.theme.color.primaryColors.darkPurple};
        text-align: justify;
        opacity: 0.7;
      }
    }
  }

  @media only screen and (max-width: 1450px) {
    padding: 0px 100px;
  }

  @media only screen and (max-width: 1024px) {
    padding: 0px 80px;
  }

  /* MOBILE*/
  @media only screen and (max-width: 815px) {
    padding: 0 40px;

    .privacyPolicyBlock {
      flex-direction: column;
    }

    .privacyPolicyContentBlock {
      width: 100%;
    }
    .privacyPolicyTitle {
      flex-direction: column;

      .privacyTitle {
        width: 100%;
      }
    }

    .PrivacyPolicyTopicBlock {
      width: 100%;
    }
  }

  /* MOBILE MEDIUM*/
  @media only screen and (max-width: 650px) {
    gap: 16px;
  }

  /* MOBILE SMALL*/
  @media only screen and (max-width: 390px) {
  }
`;

export class PrivacyPolicy extends BaseComponent {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledPrivacyPolicy className="" alignItems="flex-start" flexDirection="column" justifyContent="flex-start">
        <NanoFlex className="privacyPolicyTitle">
          <NanoFlex className="spacer"></NanoFlex>
          <NanoFlex className="privacyTitle" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
            <Type.h3>{this.translation.contactForm.privacyPolicy}</Type.h3>

            <Type.p>{this.translation.contactForm.privacyPolicyPage.textBlockOne}</Type.p>
            <Type.p>{this.translation.contactForm.privacyPolicyPage.textBlockTwo}</Type.p>
          </NanoFlex>
        </NanoFlex>
        <NanoFlex className="privacyPolicyBlock">
          <NanoFlex className="PrivacyPolicyTopicBlock" justifyContent="flex-start" alignItems="flex-start">
            <Type.p>{this.translation.homepage.recruitmentProcess.forCandidates}</Type.p>
          </NanoFlex>
          <NanoFlex className="privacyPolicyContentBlock" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <NanoFlex className="articleContent" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
              <Type.p>{this.translation.contactForm.privacyPolicyPage.forCandidates.textBlockOne}</Type.p>
              <Type.p>{this.translation.contactForm.privacyPolicyPage.forCandidates.textBlockTwo}</Type.p>
            </NanoFlex>
            <NanoFlex className="articleSubtitle" justifyContent="flex-start">
              <Type.h5>{this.translation.contactForm.privacyPolicyPage.titleArticleOne}</Type.h5>
            </NanoFlex>
            <NanoFlex className="articleContent" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
              <Type.p>{this.translation.contactForm.privacyPolicyPage.forCandidates.textBlockThree}</Type.p>
              <Type.p dangerouslySetInnerHTML={{ __html: this.translation.contactForm.privacyPolicyPage.forCandidates.textBlockFour }}></Type.p>
            </NanoFlex>

            <NanoFlex className="articleSubtitle" justifyContent="flex-start">
              <Type.h5>{this.translation.contactForm.privacyPolicyPage.titleArticleTwo}</Type.h5>
            </NanoFlex>

            <NanoFlex className="articleContent" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
              <Type.p dangerouslySetInnerHTML={{ __html: this.translation.contactForm.privacyPolicyPage.forCandidates.textBlockFive }}></Type.p>
            </NanoFlex>

            <NanoFlex className="articleSubtitle" justifyContent="flex-start">
              <Type.h5>{this.translation.contactForm.privacyPolicyPage.titleArticleThree}</Type.h5>
            </NanoFlex>

            <NanoFlex className="articleContent" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
              <Type.p>{this.translation.contactForm.privacyPolicyPage.forCandidates.textBlockSix}</Type.p>
              <Type.p>{this.translation.contactForm.privacyPolicyPage.forCandidates.textBlockSixPartTwo}</Type.p>
              <Type.p>{this.translation.contactForm.privacyPolicyPage.forCandidates.textBlockSixPartThree}</Type.p>
              <Type.p dangerouslySetInnerHTML={{ __html: this.translation.contactForm.privacyPolicyPage.forCandidates.textBlockSixPartFour }}></Type.p>
            </NanoFlex>

            <NanoFlex className="articleSubtitle" justifyContent="flex-start">
              <Type.h5>{this.translation.contactForm.privacyPolicyPage.titleArticleFour}</Type.h5>
            </NanoFlex>
            <NanoFlex className="articleContent" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
              <Type.p dangerouslySetInnerHTML={{ __html: this.translation.contactForm.privacyPolicyPage.forCandidates.textBlockSeven }}></Type.p>
            </NanoFlex>

            <NanoFlex className="articleSubtitle" justifyContent="flex-start">
              <Type.h5>{this.translation.contactForm.privacyPolicyPage.titleArticleFive}</Type.h5>
            </NanoFlex>

            <NanoFlex className="articleContent" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
              <Type.p dangerouslySetInnerHTML={{ __html: this.translation.contactForm.privacyPolicyPage.forCandidates.textBlockEight }}></Type.p>
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
        <NanoFlex className="privacyPolicyBlock">
          <NanoFlex className="PrivacyPolicyTopicBlock" justifyContent="flex-start" alignItems="flex-start">
            <Type.p>{this.translation.homepage.recruitmentProcess.forCompanies}</Type.p>
          </NanoFlex>
          <NanoFlex className="privacyPolicyContentBlock" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <NanoFlex className="articleContent" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
              <Type.p>{this.translation.contactForm.privacyPolicyPage.forClients.textBlockOne}</Type.p>
              <Type.p>{this.translation.contactForm.privacyPolicyPage.forClients.textBlockTwo}</Type.p>
            </NanoFlex>

            <NanoFlex className="articleSubtitle" justifyContent="flex-start">
              <Type.h5>{this.translation.contactForm.privacyPolicyPage.titleArticleOne}</Type.h5>
            </NanoFlex>

            <NanoFlex className="articleContent" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
              <Type.p dangerouslySetInnerHTML={{ __html: this.translation.contactForm.privacyPolicyPage.forClients.textBlockThree }}></Type.p>
            </NanoFlex>

            <NanoFlex className="articleSubtitle" justifyContent="flex-start">
              <Type.h5>{this.translation.contactForm.privacyPolicyPage.titleArticleTwo}</Type.h5>
            </NanoFlex>

            <NanoFlex className="articleContent" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
              <Type.p>{this.translation.contactForm.privacyPolicyPage.forClients.textBlockFour}</Type.p>
              <Type.p dangerouslySetInnerHTML={{ __html: this.translation.contactForm.privacyPolicyPage.forClients.textBlockFourPartTwo }}></Type.p>
              <Type.p>{this.translation.contactForm.privacyPolicyPage.forClients.textBlockFourPartThree}</Type.p>
              <Type.p>{this.translation.contactForm.privacyPolicyPage.forClients.textBlockFourPartFour}</Type.p>
              <Type.p dangerouslySetInnerHTML={{ __html: this.translation.contactForm.privacyPolicyPage.forClients.textBlockFourPartFive }}></Type.p>
              <Type.p dangerouslySetInnerHTML={{ __html: this.translation.contactForm.privacyPolicyPage.forClients.textBlockFourPartSix }}></Type.p>
            </NanoFlex>

            <NanoFlex className="articleSubtitle" justifyContent="flex-start">
              <Type.h5>{this.translation.contactForm.privacyPolicyPage.forClients.titleArticleThree}</Type.h5>
            </NanoFlex>

            <NanoFlex className="articleContent" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
              <Type.p dangerouslySetInnerHTML={{ __html: this.translation.contactForm.privacyPolicyPage.forClients.textBlockFive }}></Type.p>
              <Type.p dangerouslySetInnerHTML={{ __html: this.translation.contactForm.privacyPolicyPage.forClients.textBlockFivePartTwo }}></Type.p>
              <Type.p dangerouslySetInnerHTML={{ __html: this.translation.contactForm.privacyPolicyPage.forClients.textBlockFivePartThree }}></Type.p>
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
      </StyledPrivacyPolicy>
    );
  }
}
